/**
 * Web portal auth configuration
 *
 * Uses @mzanzi/auth shared package for MSAL setup.
 * Web-specific: redirect URIs, no staff check.
 */
import { createMsalConfig } from '@mzanzi/auth';

const TENANT_NAME = 'mzanzi';
const TENANT_ID = 'b3551fcd-fe0d-437a-b90c-499156bc8a84';
const CLIENT_ID = import.meta.env.VITE_ENTRA_CLIENT_ID || '9d23bd8d-5c3c-40b4-85da-7b1962886096';

function getRedirectUri(): string {
  if (import.meta.env.DEV) return 'http://localhost:5173/auth/callback';
  if (typeof window !== 'undefined' && window.location.hostname.includes('pages.dev')) {
    return `${window.location.origin}/auth/callback`;
  }
  return 'https://mzanzi.cloud/auth/callback';
}

function getPostLogoutUri(): string {
  if (import.meta.env.DEV) return 'http://localhost:5173';
  if (typeof window !== 'undefined' && window.location.hostname.includes('pages.dev')) {
    return window.location.origin;
  }
  return 'https://mzanzi.cloud';
}

export const msalConfig = createMsalConfig({
  tenantName: TENANT_NAME,
  tenantId: TENANT_ID,
  clientId: CLIENT_ID,
  redirectUri: getRedirectUri(),
  postLogoutRedirectUri: getPostLogoutUri(),
});
